/**
 * The dash a table cell shows when it has no value — one spelling, because three tables rendering
 * « — » at three sizes is how a column quietly starts looking like a different kind of empty.
 *
 * It asserts nothing: "no value here", never "zero" and never "not loaded". A cell that means one
 * of those says it in words instead.
 */
const EmptyCell = () => <span className="text-[13px] text-muted-foreground/70">—</span>;

export default EmptyCell;
